(function () {
  var STORAGE_KEY = 'maison1822_quote_list';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateBadges();
    updateIndicators();
    document.dispatchEvent(new CustomEvent('quotelist:updated', { detail: { list: list } }));
  }

  function add(item) {
    var list = getAll();
    var exists = list.some(function (i) { return i.sku === item.sku; });
    if (!exists) {
      list.push(item);
      save(list);
    }
    return list;
  }

  function removeAt(index) {
    var list = getAll();
    list.splice(index, 1);
    save(list);
  }

  function clearAll() {
    save([]);
  }

  function updateBadges() {
    var count = getAll().length;
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // MAISON 1822 : indicateur "deja dans ma selection" sur les fiches produit
  function updateIndicators() {
    var skus = getAll().map(function (i) { return i.sku; });
    document.querySelectorAll('[data-quote-indicator]').forEach(function (el) {
      el.hidden = skus.indexOf(el.dataset.quoteIndicator) === -1;
    });
  }

  window.QuoteList = { getAll: getAll, add: add, removeAt: removeAt, clear: clearAll };

  function renderPanel() {
    var panel = document.getElementById('quote-list-panel');
    if (!panel) return;
    var list = getAll();
    var listEl = panel.querySelector('[data-quote-items]');
    var emptyEl = panel.querySelector('[data-quote-empty]');
    var clearBtn = panel.querySelector('[data-quote-clear]');
    var textarea = document.getElementById('message');

    if (!list.length) {
      if (listEl) listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (clearBtn) clearBtn.hidden = true;
      // MAISON 1822 : vider aussi le message pre-rempli quand la selection est videe
      if (textarea && !textarea.dataset.userEdited) {
        textarea.value = '';
      }
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (clearBtn) clearBtn.hidden = false;

    if (listEl) {
      listEl.innerHTML = list.map(function (item, index) {
        return '<li style="display:flex;align-items:center;justify-content:space-between;gap:0.75rem;padding:0.5rem 0;border-bottom:1px solid rgba(255,255,255,0.14);">' +
          '<span><a href="' + item.url + '" style="text-decoration:underline;">' + item.title + '</a>' +
          (item.variant ? ' — ' + item.variant : '') + '</span>' +
          '<button type="button" data-quote-remove="' + index + '" aria-label="Retirer" style="background:none;border:none;cursor:pointer;color:#b03a2e;font-size:1.1em;">✕</button>' +
        '</li>';
      }).join('');
    }

    if (textarea && !textarea.dataset.userEdited) {
      var lines = list.map(function (item) {
        return '- ' + item.title + (item.variant ? ' (' + item.variant + ')' : '') + (item.sku ? ' — SKU ' + item.sku : '');
      });
      // MAISON 1822 : intro/outro localisees via les data-attributes du panneau (traduction Liquid)
      var introText = panel.dataset.messageIntro || 'Bonjour, je souhaite obtenir vos tarifs dégressifs pour les vins suivants :';
      var outroText = panel.dataset.messageOutro || 'Merci de me recontacter.';
      textarea.value = introText + '\n\n' + lines.join('\n') + '\n\n' + outroText;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    updateIndicators();
    renderPanel();
  });

  // MAISON 1822 : re-verifie l'indicateur quand le selecteur de variante change de fiche (AJAX)
  document.addEventListener('on:variant:change', updateIndicators);

  document.addEventListener('quotelist:updated', renderPanel);

  document.addEventListener('click', function (evt) {
    var addBtn = evt.target.closest('[data-quote-add]');
    if (addBtn) {
      evt.preventDefault();
      add({
        title: addBtn.dataset.productTitle,
        variant: addBtn.dataset.variantTitle,
        sku: addBtn.dataset.sku,
        url: addBtn.dataset.productUrl
      });
      var originalLabel = addBtn.dataset.originalLabel || addBtn.textContent;
      addBtn.textContent = addBtn.dataset.addedLabel || 'Ajouté ✓';
      addBtn.disabled = true;
      setTimeout(function () {
        addBtn.textContent = originalLabel;
        addBtn.disabled = false;
      }, 2000);
      return;
    }

    var removeBtn = evt.target.closest('[data-quote-remove]');
    if (removeBtn) {
      removeAt(parseInt(removeBtn.dataset.quoteRemove, 10));
      return;
    }

    var clearBtn = evt.target.closest('[data-quote-clear]');
    if (clearBtn) {
      clearAll();
      return;
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.id === 'message') {
      evt.target.dataset.userEdited = 'true';
    }
  });
})();
